export default __webpack_public_path__ + "static/media/nftSystemCenter.77bbdd62.png";